// import { Input } from "antd";
// import { useEffect, useMemo, useState } from "react";

// const TextEditorOverlay = ({
//   textAnnotations,
//   selectedText,
//   displaySize,
//   canvasSize,
//   getTextBounds,
//   onChange, // (id, value) — called ONLY on Save
//   onCommit, // (id)        — sets isEditing:false + history
//   onCancel, // (id)        — sets isEditing:false (no change)
// }) => {
//   // find the one we’re editing
//   const ann = useMemo(
//     () => textAnnotations.find((a) => a.isEditing && a.id === selectedText),
//     [textAnnotations, selectedText]
//   );

//   const [draft, setDraft] = useState(ann?.text ?? "");

//   // sync local draft when a different annotation is opened
//   useEffect(() => {
//     setDraft(ann?.text ?? "");
//   }, [ann?.id]);

//   if (!ann) return null;

//   // canvas → display scale
//   const bounds = getTextBounds(ann); // x,y,width,height in canvas space
//   const scaleX = displaySize.width / canvasSize.width;
//   const scaleY = displaySize.height / canvasSize.height;

//   // actions
//   const save = (e) => {
//     e?.preventDefault?.();
//     e?.stopPropagation?.();
//     onChange?.(ann.id, draft);
//     onCommit?.(ann.id);
//   };

//   const cancel = (e) => {
//     e?.preventDefault?.();
//     e?.stopPropagation?.();
//     onCancel?.(ann.id);
//   };

//   return (
//     <div
//       className="absolute z-50 bg-white min-h-[100px] max-h-auto"
//       style={{
//         left: bounds.x * scaleX,
//         top: bounds.y * scaleY,
//         width: bounds.width * scaleX,
//         height: bounds.height * scaleY,
//       }}
//       onMouseDown={(e) => e.stopPropagation()} // don’t trigger canvas pan/select
//     >

//       <div className="space-y-2">
//         <Input.TextArea
//           value={draft}
//           onChange={(e) => setDraft(e.target.value)}
//           onKeyDown={(e) => {
//             if (e.key === "Enter" && !e.shiftKey) {
//               e.preventDefault();
//               save(e);
//             } else if (e.key === "Escape") {
//               e.preventDefault();
//               cancel(e);
//             }
//           }}
//           autoSize={{ minRows: 2, maxRows: 10 }} // 👈 auto-resizing
//           placeholder="Edit comment..."
//           className="!rounded-[8px]"
//         />
//         <div className="flex gap-2 items-center justify-between ">
//           <div
//             // onClick={handleCancelEdit}
//             className="bg-white border font-semibold h-[32px] w-[80px] text-[#8C8C8C] rounded-[7px] flex items-center justify-center text-[16px]"
//           >
//             Cancel
//           </div>
//           <div
//             // onClick={handleSaveEdit}
//             className="bg-[#20C3FF] font-semibold h-[32px] w-[80px] text-white rounded-[7px] flex items-center justify-center text-[16px]"
//           >
//             Send
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TextEditorOverlay;

import { Input } from "antd";
import { useEffect, useMemo, useState } from "react";

const TextEditorOverlay = ({
  textAnnotations,
  selectedText,
  displaySize,
  canvasSize,
  getTextBounds,
  onChange, // (id, value) — called ONLY on Save
  onCommit, // (id)        — sets isEditing:false + history
  onCancel, // (id)        — sets isEditing:false (no change)
}) => {
  // find the one we’re editing
  const ann = useMemo(
    () => textAnnotations.find((a) => a.isEditing && a.id === selectedText),
    [textAnnotations, selectedText]
  );

  const [draft, setDraft] = useState(ann?.text ?? "");

  // sync local draft when a different annotation is opened
  useEffect(() => {
    setDraft(ann?.text ?? "");
  }, [ann?.id]);

  if (!ann) return null;

  // canvas → display scale
  const bounds = getTextBounds(ann); // x,y,width,height in canvas space
  const scaleX = displaySize.width / canvasSize.width;
  const scaleY = displaySize.height / canvasSize.height;

  // actions
  const save = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    onChange?.(ann.id, draft);
    onCommit?.(ann.id);
  };

  const cancel = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    onCancel?.(ann.id);
  };

  return (
    <div
      className="absolute z-50"
      style={{
        left: bounds.x * scaleX,
        top: bounds.y * scaleY,
        width: bounds.width * scaleX, // keep width aligned to text box
        // IMPORTANT: let height grow with content so buttons are visible
        height: "auto",
        // optional niceties:
        background: "white",
        borderRadius: 8,
        boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
        padding: 8,
      }}
      onMouseDown={(e) => e.stopPropagation()} // don’t trigger canvas pan/select
    >
      <div className="space-y-2">
        <Input.TextArea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              save(e);
            } else if (e.key === "Escape") {
              e.preventDefault();
              cancel(e);
            }
          }}
          // auto grows vertically with content
          autoSize={{ minRows: 2, maxRows: 12 }}
          placeholder="Type your text…"
          className="!rounded-[8px]"
        />

        {/* Buttons under the textarea */}
        <div className="flex items-center justify-between pt-1">
          <button
            type="button"
            onClick={cancel}
            className="bg-white border font-semibold h-[32px] w-[80px] text-[#8C8C8C] rounded-[7px] flex items-center justify-center text-[14px]"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={save}
            className="bg-[#20C3FF] font-semibold h-[32px] w-[80px] text-white rounded-[7px] flex items-center justify-center text-[14px]"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextEditorOverlay;
